/* =========================================================
   Quick Add — direct add, variant popup, open UpCart drawer
   Works with UpCart (AfterSell) via its public API, with
   graceful fallbacks if the API is unavailable.
   ========================================================= */
(function () {
  'use strict';

  var CART_ADD_URL =
    (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';
  var STRINGS = {
    add: 'Add to Cart',
    soldOut: 'Sold out',
    choose: 'Choose an option',
    error: 'Sorry, this item could not be added to the cart.'
  };
  if (window.theme && window.theme.strings && window.theme.strings.soldOut) {
    STRINGS.soldOut = window.theme.strings.soldOut;
  }

  var modal, optionsEl, submitEl, dialogEl;
  var currentData = null;
  var selectedValues = [];
  var currentVariantId = null;

  /* ---------------- UpCart drawer open ---------------- */
  function openCartDrawer() {
    var opened = false;
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
    } catch (e) {}
    try {
      if (typeof window.upcartOpenCart === 'function') {
        window.upcartOpenCart();
        opened = true;
      }
    } catch (e) {}

    if (opened) return;

    /* Fallbacks for when the UpCart API is not present */
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    } catch (e) {}
    var triggers = [
      '#upCartStickyButton',
      '.js-drawer-open-cart',
      '.js-drawer-open-right',
      '[data-drawer-toggle="CartDrawer"]',
      '.site-header__cart',
      '#cart-icon-bubble'
    ];
    for (var i = 0; i < triggers.length; i++) {
      var el = document.querySelector(triggers[i]);
      if (el) {
        el.click();
        break;
      }
    }
  }

  /* ---------------- Add to cart ---------------- */
  function addToCart(variantId, loadingEl) {
    if (!variantId) return Promise.resolve();
    if (loadingEl) loadingEl.classList.add('is-loading');

    return fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok) throw res.data;
        closeModal();
        /* Let UpCart register the change if it exposes the hook */
        try {
          if (typeof window.upcartRegisterAddToCart === 'function') {
            window.upcartRegisterAddToCart();
          }
        } catch (e) {}
        openCartDrawer();
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || STRINGS.error;
        window.alert(msg);
      })
      .then(function () {
        if (loadingEl) loadingEl.classList.remove('is-loading');
      });
  }

  /* ---------------- Modal build ---------------- */
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'quick-add-modal';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="quick-add-modal__overlay" data-qa-close></div>' +
      '<div class="quick-add-modal__dialog" role="dialog" aria-modal="true" aria-label="Select options">' +
      '<button type="button" class="quick-add-modal__close" data-qa-close aria-label="Close">&times;</button>' +
      '<div class="quick-add-modal__options" data-qa-options></div>' +
      '<button type="button" class="quick-add-modal__submit" data-qa-submit>' +
      STRINGS.add +
      '</button>' +
      '</div>';
    document.body.appendChild(modal);

    optionsEl = modal.querySelector('[data-qa-options]');
    submitEl = modal.querySelector('[data-qa-submit]');
    dialogEl = modal.querySelector('.quick-add-modal__dialog');

    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-qa-close')) closeModal();
    });
    submitEl.addEventListener('click', function () {
      if (submitEl.disabled) return;
      addToCart(currentVariantId, submitEl);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) closeModal();
    });
  }

  /* ---------------- Variant helpers ---------------- */
  function variantKey(values) {
    return values.join('~~');
  }
  function findVariant(values) {
    var key = variantKey(values);
    for (var i = 0; i < currentData.variants.length; i++) {
      if (variantKey(currentData.variants[i].options) === key) return currentData.variants[i];
    }
    return null;
  }
  function valueHasStock(optionIndex, value) {
    for (var i = 0; i < currentData.variants.length; i++) {
      var v = currentData.variants[i];
      if (v.options[optionIndex] === value && v.available) return true;
    }
    return false;
  }

  function updateSubmit() {
    var v = findVariant(selectedValues);
    if (v && v.available) {
      currentVariantId = v.id;
      submitEl.disabled = false;
      submitEl.textContent = STRINGS.add;
    } else {
      currentVariantId = null;
      submitEl.disabled = true;
      submitEl.textContent = STRINGS.soldOut;
    }
  }

  function renderOptions() {
    optionsEl.innerHTML = '';
    currentData.options.forEach(function (optionName, optionIndex) {
      var seen = {};
      var group = document.createElement('div');
      group.className = 'quick-add-option';

      var label = document.createElement('span');
      label.className = 'quick-add-option__name';
      label.textContent = optionName;
      group.appendChild(label);

      var values = document.createElement('div');
      values.className = 'quick-add-option__values';

      currentData.variants.forEach(function (v) {
        var value = v.options[optionIndex];
        if (seen[value]) return;
        seen[value] = true;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quick-add-value';
        btn.textContent = value;
        btn.setAttribute('data-option-index', optionIndex);
        btn.setAttribute('data-value', value);

        if (!valueHasStock(optionIndex, value)) {
          btn.classList.add('is-unavailable');
          btn.disabled = true;
        }
        if (selectedValues[optionIndex] === value) btn.classList.add('is-selected');

        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          selectedValues[optionIndex] = value;
          Array.prototype.forEach.call(values.children, function (c) {
            c.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          updateSubmit();
        });

        values.appendChild(btn);
      });

      group.appendChild(values);
      optionsEl.appendChild(group);
    });
  }

  /* ---------------- Modal open/close ---------------- */
  function openModal(data) {
    if (!modal) buildModal();
    currentData = data;

    /* Default selection = first available variant, else first variant */
    var base = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].available) {
        base = data.variants[i];
        break;
      }
    }
    if (!base) base = data.variants[0];
    selectedValues = base.options.slice();

    renderOptions();
    updateSubmit();

    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    /* trigger transition */
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
  }

  function closeModal() {
    if (!modal || modal.hasAttribute('hidden')) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (modal) modal.setAttribute('hidden', '');
    }, 200);
  }

  /* ---------------- Data lookup ---------------- */
  function getVariantData(productId) {
    var el = document.querySelector('[data-quick-add-json="' + productId + '"]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* ---------------- Click delegation ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add-btn]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var available = btn.getAttribute('data-available') === 'true';
    var hasVariants = btn.getAttribute('data-has-variants') === 'true';

    if (hasVariants) {
      var data = getVariantData(btn.getAttribute('data-product-id'));
      if (data && data.variants && data.variants.length) {
        openModal(data);
        return;
      }
      /* No data found — fall through to direct add */
    }

    if (!available) return;
    addToCart(btn.getAttribute('data-variant-id'), btn);
  });
})();
